import { ListAreaTicketsDTO } from '../models/AreaTickets'
import { TicketRepository } from '../repositories/TicketRepository'

export function ListTicketsAreaCase(ticketRepository: TicketRepository) {
  return async function ({
    areaId,
    data
  }: {
    areaId: string
    data: ListAreaTicketsDTO
  }) {
    return await ticketRepository.listTicketsArea({
      areaId,
      data
    })
  }
}
